import { LockOutlined, WarningOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { yellow } from '@ant-design/colors'
import { Tooltip } from 'antd'
import { BalanceError } from '../../../../../redux/context/reports/types'

interface RestrictedProps {
  errors?: BalanceError[]
}

const Restricted: React.FC<RestrictedProps> = ({ errors }) => {
  const { t } = useTranslation()

  const generateErrorMessages = () => {
    return errors && errors.length ? errors.map(err => t(`error:${err}`)).join(' • ') : undefined
  }

  const errorIncludesUnauthorized = () => {
    if (errors?.find((e: BalanceError) => e === 'unauthorized')) {
      return <LockOutlined />
    }
    return <WarningOutlined style={{ color: yellow.primary }} />
  }

  return (
    <Tooltip title={generateErrorMessages()} placement="top">
      {errorIncludesUnauthorized()}
    </Tooltip>
  )
}

export default Restricted
